import { ThemedView } from "@/components/ThemedView";
import "expo-dev-client"; // if you're using dev client
import { ActivityIndicator } from "react-native";
import { SafeAreaProvider } from "react-native-safe-area-context";
globalThis.global = globalThis;

export default function StartPage() {
  // In this setup, the _layout.tsx will handle the redirection.
  // You can simply show a loading spinner or use a Redirect component
  // if you want to be explicit, though the layout effect is often sufficient.

  // return <Redirect href="/home" />; // This could be an alternative
  return (
    <SafeAreaProvider>
      <ThemedView
        style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
      >
        <ActivityIndicator size="large" />
      </ThemedView>
    </SafeAreaProvider>
  );
}
